module.exports = __webpack_public_path__ + "static/media/check.4cb6f6ac.png";